/* biome-ignore-all lint/suspicious: use ES5-compatible syntax for non-module usage in /legacy and /demo/* pages */
(function () {
    var sessionStarted = false;
    var onlineHandler;

    function startSession() {
        if (sessionStarted || !navigator.onLine || navigator.globalPrivacyControl) {
            return;
        }
        if (onlineHandler) {
            if (window.removeEventListener) {
                window.removeEventListener("online", onlineHandler);
            }
            onlineHandler = undefined;
        }

        sessionStarted = true;

        try {
            var metrics = {
                t: document.title,
                x: Math.random(),
                w: screen.width,
                h: screen.height,
                j: innerHeight,
                e: innerWidth,
                l: location.href,
                r: document.referrer,
                k: screen.colorDepth,
                n: document.characterSet,
                o: new Date().getTimezoneOffset(),
            };
            fetch("/api/pulse", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                keepalive: true,
                body: JSON.stringify({
                    name: "pageview",
                    data: metrics,
                    zarazData: metrics,
                }),
            });
        } catch (error) {
            console.error(error);
        }
    }

    if (sessionStarted || navigator.globalPrivacyControl) {
        return;
    }
    if (navigator.onLine) {
        startSession();
        return;
    }
    if (!onlineHandler) {
        onlineHandler = startSession;
        addEventListener("online", onlineHandler);
    }
})();
